import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { getCountries, getIdList } from "./../../Utils/api";
import AddUpdateState from "../../Components/AddUpdateState";
import AddStateCsv from "../../Components/AddStateCsv";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function State() {
  const [states, setStates] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notAdmin, setNotAdmin] = useState(false);
  const [searchFilter, setSearchFilter] = useState("");
  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalStates, setTotalStates] = useState(0);

  // Location
  const [country, setCountry] = useState([]);
  const [inputCountry, setInputCountry] = useState("");

  const [countryOpt, setCountryOpt] = useState("");
  const [allCountry, setAllCountry] = useState([]);

  const fetchCountryData = (inputValue) => getCountries(inputValue);

  // get country option
  useEffect(() => {
    const params = {};
    getAxiosInstance()
      .post("/admin/countries", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        console.log(res.data.result);
        setAllCountry(res.data.result);
      })
      .catch((err) => console.log(err));
  }, []);

  const getStates = () => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      country: countryOpt,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/states", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalStates(res.data.totalCount);
          setStates(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getStates();
  }, [limit, pageNumber, country, countryOpt]);

  const changePage = ({ selected }) => setPageNumber(selected);

  const deleteState = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      html: "<h5>This state will be deleted?</h5>",
      showCancelButton: true,
      confirmButtonText: `Delete`,
      confirmButtonColor: "#D14343",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const params = { id: id };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");

        getAxiosInstance()
          .post("/admin/delete-state", data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // Validating form
            setIsLoading(false);
            if (res.data.status === "success") {
              Toast.fire({
                icon: "success",
                title: "Successfully deleted state",
              });
              getStates();
            } else {
              console.log(res.data);
              Toast.fire({ icon: "error", title: "Unable to delete state" });
            }
          })
          .catch((err) => {
            Toast.fire({ icon: "error", title: "Unexpected Error" });
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  };

  useEffect(() => {
    getAxiosInstance()
      .get("/admin/me")
      .then((res) => {
        if (res.data.result.user_type !== "admin") {
          setNotAdmin(true);
          setCountry(res.data.result.location.country);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">State</h1>
              </div>
              <div className="col-sm-6">
                <div className="float-right">
                  <AddStateCsv
                    getAxiosInstance={getAxiosInstance}
                    Toast={Toast}
                    getStates={getStates}
                  />
                  <AddUpdateState
                    type={"add"}
                    getAxiosInstance={getAxiosInstance}
                    Toast={Toast}
                    getStates={getStates}
                    getCountries={getCountries}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Countries"
                  value={country}
                  isDisabled={notAdmin}
                  getOptionLabel={(e) => `${e.name} (${e.code})`}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchCountryData}
                  onInputChange={setInputCountry}
                  onChange={setCountry}
                /> */}
                <select onChange={(e) => setCountryOpt(e.target.value)}>
                  <option>Select Country---</option>
                  {allCountry.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div class="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: 250 }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          value={searchFilter}
                          onChange={(e) => setSearchFilter(e.target.value)}
                        />
                        <div className="input-group-append">
                          <button
                            type="submit"
                            className="btn btn-default"
                            onClick={() => getStates()}
                          >
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 100 }}>ID</th>
                          <th>State</th>
                          <th>Country</th>
                          <th style={{ width: 40 }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={5}>Loading States ...</td>
                          </tr>
                        )}
                        {!isLoading && totalStates === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={5}>No States Found</td>
                          </tr>
                        )}
                        {states?.map((state, i) => (
                          <tr key={i}>
                            <td>{state.uid || state.id}</td>
                            <td>{state.name}</td>
                            <td>{state.country.name}</td>
                            <td>
                              <div style={{ display: "flex" }}>
                                <AddUpdateState
                                  type={"update"}
                                  getAxiosInstance={getAxiosInstance}
                                  Toast={Toast}
                                  getStates={getStates}
                                  getCountries={getCountries}
                                  stateUp={state}
                                />
                                <button
                                  type="button"
                                  class="btn btn-danger btn-sm ml-1"
                                  title="Delete"
                                  onClick={() => deleteState(state._id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalStates > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalStates / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
